import type { DealScoreDialogProps } from "./DealScoreDialogComponent"
import { lazy } from "react"

const Component = lazy(() => import("./DealScoreDialogComponent"))
export function DealScoreDialog(props: DealScoreDialogProps) {
    return <Component {...props} />
}
